import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import EdgeIntersection from './EdgeIntersection';
import Coordinate from '../geom/Coordinate';
import Label from './Label';
import Edge from './Edge';
import TreeMap from '../../../../java/util/TreeMap';
var EdgeIntersectionList = /*#__PURE__*/function () {
  function EdgeIntersectionList() {
    _classCallCheck(this, EdgeIntersectionList);
    EdgeIntersectionList.constructor_.apply(this, arguments);
  }
  _createClass(EdgeIntersectionList, [{
    key: "print",
    value: function print(out) {
      out.println('Intersections:');
      for (var it = this.iterator(); it.hasNext();) {
        var ei = it.next();
        ei.print(out);
      }
    }
  }, {
    key: "iterator",
    value: function iterator() {
      return this._nodeMap.values().iterator();
    }
  }, {
    key: "addSplitEdges",
    value: function addSplitEdges(edgeList) {
      this.addEndpoints();
      var it = this.iterator();
      var eiPrev = it.next();
      while (it.hasNext()) {
        var ei = it.next();
        var newEdge = this.createSplitEdge(eiPrev, ei);
        edgeList.add(newEdge);
        eiPrev = ei;
      }
    }
  }, {
    key: "addEndpoints",
    value: function addEndpoints() {
      var maxSegIndex = this.edge.pts.length - 1;
      this.add(this.edge.pts[0], 0, 0.0);
      this.add(this.edge.pts[maxSegIndex], maxSegIndex, 0.0);
    }
  }, {
    key: "createSplitEdge",
    value: function createSplitEdge(ei0, ei1) {
      var npts = ei1.segmentIndex - ei0.segmentIndex + 2;
      var lastSegStartPt = this.edge.pts[ei1.segmentIndex];
      var useIntPt1 = ei1.dist > 0.0 || !ei1.coord.equals2D(lastSegStartPt);
      if (!useIntPt1) npts--;
      var pts = new Array(npts).fill(null);
      var ipt = 0;
      pts[ipt++] = new Coordinate(ei0.coord);
      for (var i = ei0.segmentIndex + 1; i <= ei1.segmentIndex; i++) pts[ipt++] = this.edge.pts[i];
      if (useIntPt1) pts[ipt] = ei1.coord;
      return new Edge(pts, new Label(this.edge._label));
    }
  }, {
    key: "add",
    value: function add(intPt, segmentIndex, dist) {
      var eiNew = new EdgeIntersection(intPt, segmentIndex, dist);
      var ei = this._nodeMap.get(eiNew);
      if (ei !== null) return ei;
      this._nodeMap.put(eiNew, eiNew);
      return eiNew;
    }
  }, {
    key: "isIntersection",
    value: function isIntersection(pt) {
      for (var it = this.iterator(); it.hasNext();) {
        var ei = it.next();
        if (ei.coord.equals(pt)) return true;
      }
      return false;
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._nodeMap = new TreeMap();
      this.edge = null;
      var edge = arguments[0];
      this.edge = edge;
    }
  }]);
  return EdgeIntersectionList;
}();
export { EdgeIntersectionList as default };